export default __webpack_public_path__ + "static/media/person.1205b157.png";